import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTeamState } from '../../Fodboldhold/store'
import { TeamMark } from '../../Fodboldhold/bits'
import './HoldAdmin.css'

function countLabel(count, one, many) {
  return `${count} ${count === 1 ? one : many}`
}

export default function HoldAdmin() {
  const navigate = useNavigate()
  const { state, dispatch } = useTeamState()
  const teams = state.allTeams
  const [name, setName] = useState('')
  const [seasonName, setSeasonName] = useState('Efterår 2026')
  const canCreate = name.trim().length > 0 && seasonName.trim().length > 0

  return (
    <div className="hold-admin">
      <section className="hold-admin-section">
        <p className="hold-admin-meta">{state.loadingAll ? 'Henter hold…' : countLabel(teams.length, 'hold', 'hold')}</p>
        {state.adminError || state.error ? <p className="hold-admin-empty">{state.adminError || state.error}</p> : null}
        {!state.loadingAll && teams.length === 0 ? (
          <p className="hold-admin-empty">Der er ingen hold endnu.</p>
        ) : (
          <ul className="hold-admin-list">
            {teams.map((team) => {
              const season = team.seasons.find((item) => item.current)
              return (
                <li key={team.id}>
                  <button type="button" onClick={() => navigate(`/hold/${team.id}`)}>
                    <TeamMark team={team} className="hold-admin-mark" />
                    <span className="hold-admin-copy">
                      <strong>{team.name}</strong>
                      <span className="hold-admin-meta">
                        {season?.name || 'Ingen sæson'}
                        {' · '}
                        {countLabel(team.members.length, 'medlem', 'medlemmer')}
                      </span>
                    </span>
                    <svg className="hold-admin-chevron" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M9 6.5 15 12l-6 5.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </li>
              )
            })}
          </ul>
        )}
      </section>

      <form
        className="hold-admin-form"
        onSubmit={async (event) => {
          event.preventDefault()
          if (!canCreate) return
          const result = await dispatch({ type: 'ADD_TEAM', name, seasonName })
          if (result.ok) setName('')
        }}
      >
        <h2>Nyt hold</h2>
        <label>
          Holdnavn
          <input value={name} onChange={(event) => setName(event.target.value)} placeholder="Svirr IF" />
        </label>
        <label>
          Første sæson
          <input value={seasonName} onChange={(event) => setSeasonName(event.target.value)} />
        </label>
        <p className="hold-admin-hint">Du bliver hold-admin på holdet.</p>
        <button type="submit" className="hold-admin-submit" disabled={!canCreate}>Opret hold</button>
      </form>
    </div>
  )
}
